// Génère une image PNG de la carte de membre (fond sombre, nom, ceinture, QR, PIN) prête pour Photos.
import { beltHex, beltTextColor } from "../../lib/beltColor";
import { photoSrc } from "./PassPhoto";

function roundRect(ctx, x, y, w, h, r) {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + w, y, x + w, y + h, r);
  ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r);
  ctx.arcTo(x, y, x + w, y, r);
  ctx.closePath();
}

function loadImage(src) {
  return new Promise((resolve) => {
    if (!src) return resolve(null);
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => resolve(img);
    img.onerror = () => resolve(null);
    img.src = src;
  });
}

export function buildPassImage({ qrCanvas, name, discipline, belt, photo, pin, school, emblem }) {
  const W = 1080, H = 1620;
  const cv = document.createElement("canvas");
  cv.width = W; cv.height = H;
  const ctx = cv.getContext("2d");

  ctx.fillStyle = "#09090b";
  ctx.fillRect(0, 0, W, H);
  ctx.strokeStyle = "rgba(245,158,11,0.45)";
  ctx.lineWidth = 6;
  roundRect(ctx, 40, 40, W - 80, H - 80, 48);
  ctx.stroke();
  if (belt) {
    ctx.save();
    roundRect(ctx, 40, 40, W - 80, H - 80, 48); ctx.clip();
    ctx.fillStyle = beltHex(belt);
    ctx.fillRect(40, 40, W - 80, 22);
    ctx.restore();
  }

  ctx.textAlign = "center";
  ctx.fillStyle = "#f59e0b";
  ctx.font = "600 34px Manrope, Arial, sans-serif";
  ctx.fillText((school || "INSTITUT IMPACT ÉLITE MARTIAL").toUpperCase(), W / 2, 150);
  ctx.fillStyle = "#71717a";
  ctx.font = "500 26px Manrope, Arial, sans-serif";
  ctx.fillText("CARTE DE MEMBRE · CHECK-IN DOJO", W / 2, 198);

  let y = 320;
  if (photo) {
    const r = 110, cx = W / 2, cy = 330;
    ctx.save();
    ctx.beginPath(); ctx.arc(cx, cy, r, 0, Math.PI * 2); ctx.closePath(); ctx.clip();
    ctx.drawImage(photo, cx - r, cy - r, r * 2, r * 2);
    ctx.restore();
    ctx.beginPath(); ctx.arc(cx, cy, r + 3, 0, Math.PI * 2);
    ctx.strokeStyle = "#b45309"; ctx.lineWidth = 6; ctx.stroke();
    y = 520;
  }

  ctx.fillStyle = "#fcd34d";
  ctx.font = "700 64px Oswald, Manrope, Arial, sans-serif";
  ctx.fillText(name || "", W / 2, y);
  ctx.fillStyle = "#a1a1aa";
  ctx.font = "500 32px Manrope, Arial, sans-serif";
  const discLabel = (discipline || "").toUpperCase();
  if (emblem) {
    const es = 64, tw = ctx.measureText(discLabel).width;
    const startX = W / 2 - (tw + es + 16) / 2;
    ctx.drawImage(emblem, startX, y + 55 - es + 12, es, es);
    ctx.textAlign = "left";
    ctx.fillText(discLabel, startX + es + 16, y + 55);
    ctx.textAlign = "center";
  } else {
    ctx.fillText(discLabel, W / 2, y + 55);
  }
  if (belt) {
    const label = `CEINTURE ${belt.toUpperCase()}`;
    ctx.font = "700 28px Manrope, Arial, sans-serif";
    const tw = ctx.measureText(label).width + 60;
    ctx.fillStyle = beltHex(belt);
    roundRect(ctx, (W - tw) / 2, y + 85, tw, 52, 26); ctx.fill();
    ctx.fillStyle = beltTextColor(belt);
    ctx.fillText(label, W / 2, y + 122);
  }

  const box = photo ? 600 : 700, bx = (W - box) / 2, by = y + (belt ? 175 : 120);
  ctx.fillStyle = "#ffffff";
  roundRect(ctx, bx, by, box, box, 40);
  ctx.fill();
  if (qrCanvas) ctx.drawImage(qrCanvas, bx + 40, by + 40, box - 80, box - 80);

  if (pin) {
    ctx.fillStyle = "#71717a";
    ctx.font = "500 26px Manrope, Arial, sans-serif";
    ctx.fillText("CODE PIN DE SECOURS", W / 2, by + box + 75);
    ctx.fillStyle = "#fde68a";
    ctx.font = "700 88px monospace";
    ctx.fillText(String(pin).split("").join(" "), W / 2, by + box + 170);
  }

  ctx.fillStyle = "#52525b";
  ctx.font = "500 24px Manrope, Arial, sans-serif";
  ctx.fillText("Présente ce QR à la tablette d'accueil du dojo", W / 2, H - 90);
  return cv;
}

export async function savePassImage(opts) {
  const photo = await loadImage(opts.photoSrc);
  const emblem = await loadImage(opts.emblemSrc);
  const cv = buildPassImage({ ...opts, photo, emblem });
  const blob = await new Promise((r) => cv.toBlob(r, "image/png"));
  const file = new File([blob], `carte-impact-${(opts.name || "membre").replace(/\s+/g, "-").toLowerCase()}.png`, { type: "image/png" });
  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    try {
      await navigator.share({ files: [file], title: "Carte de membre Impact" });
      return "shared";
    } catch (e) {
      if (e?.name === "AbortError") return "cancelled";
    }
  }
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = file.name;
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 4000);
  return "downloaded";
}
